import PremiumApi from 'services/premium/api'
import GoogleMapsApi from 'services/google/maps/api'
import ConsentApi from '../../shared/consents/api'
import MapMyApi from '../../shared/mapmy/api'
import FacebookSDK from 'shared/facebook'
import AuthApi from 'services/auth/api'
import { AmplitudeSdk, EventManager } from '@uacf/web-client-events'
import YearInReviewApi from 'services/yearInReview/api'

/**
 * Given an environment of configuration options (think
 * client ids, api roots, etc...), configure all necessary
 * api instances for this app. Adding an api instance here, makes it
 * available to all actions, as the third argument passed when
 * using the thunk middleware.
 *
 * Example where 'premium' is passed in:
 *
 * export function fetchCoupon (couponCode) {
 *   return (dispatch, getState, { premium }) => {
 *     return dispatch({
 *       type: FETCH_COUPON,
 *       payload: premium.getCoupon(couponCode),
 *     })
 *   }
 * }
 *
 * @param  {Object} initialState - unhydrated server state
 * @return {Function}
 */
export default function configureApis (bootup) {
  const authToken = bootup.authToken

  const auth = new AuthApi({
    root: '/premium/auth',
    authToken: authToken,
  })

  const clientEventManager = new EventManager()

  clientEventManager.addClient(new AmplitudeSdk({
    apiKey: bootup.amplitudeApiKey,
  }))

  const fb = new FacebookSDK({
    appId: bootup.facebookAppId,
    siteDomain: bootup.facebookSiteDomain,
    version: bootup.facebookVersion,
  })

  const googleMaps = new GoogleMapsApi({
    version: bootup.googleMapsVersion,
    client: bootup.googleMapsClient,
    channel: process.env.NODE_ENV === 'production' ? window.location.host : '',
    libraries: 'geometry',
  })

  const mapmy = new MapMyApi({
    authToken: authToken,
    root: bootup.mapmyRoot,
    apiKey: bootup.mapmyApiKey,
    version: bootup.mapmyVersion,
    migrationRoot: bootup.migrationApi,
  })

  const premium = new PremiumApi({
    authToken: authToken,
    root: bootup.premiumRoot,
    apiKey: bootup.premiumClient,
    version: bootup.premiumVersion,
  })

  const yearInReview = new YearInReviewApi({})

  const consent = new ConsentApi({
    root: bootup.consentApiRoot,
    version: bootup.consentApiVersion,
    // TODO: Hardcoded to en_US, until consent API supports different locales.
    user_locale: 'en_US' || bootup.language.code,
    domain: 'MMF',
    app_domain: bootup.consentApiAppDomain,
  })

  return {
    auth,
    clientEventManager,
    fb,
    googleMaps,
    mapmy,
    premium,
    yearInReview,
    consent,
  }
}



// WEBPACK FOOTER //
// ./src/application/configureApis.js